import React, { useState, useEffect } from 'react'
import CommonSelect from './commonSelect';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getApmcPurposes, queryApplication, submitApmcFiles, updateField } from '../../../../../auth/services/privateapicalling';
import { Link } from 'react-router-dom';
import { DistrictOptions } from '../../../../../../core/data/json/apmc';
import SingleView from '../../../../district/components/SingleView';
import { formFieldDataP2, formFieldDataP3, formFieldDataP1 } from '../../../../../../core/data/json/DistrictAPMC';
import EditSection from './EditSection';
import { toast } from 'react-toastify';

interface APMCp1Props {
  token: string;
  formData: any;
  applicationId?: string;
  id?:string;
  // handleFileChange: (e: React.ChangeEvent<HTMLInputElement>, documentName: string) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

  handlePreviewFile: (fileData: any) => void;
  districtOptions: any[];
  talukaOptions: any[];
   assistanceDetails: {
    dateField: string;
    scheme2: string;
    purpose2: string;
    sanctionedAmount: string;
    assistanceReceived: string;
    totalExpenditure: string;
    shortfall: string;
    workCompletionDetails: any;
    contributionRatio: string;
  }[];
  apmcOptions: any[];
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
  editFieldValues: { [key: string]: any };
  handleEditChange: (name: string, value: any) => void;
  editFiles: { [key: string]: File | null };
  handleEditFileChange: (name: string, file: File | null) => void;
  editComment: string;
  setEditComment: (comment: string) => void;
  updatedFields: any;
  existData: any;
  userDetail: any;
  setUpdatedFields: any;
  getExistedApplication: () => void;
  unverifiedFields: string[]; // New prop
  userRole: string; // New prop
    resubmittedFields:any;
  setResubmittedFields: React.Dispatch<React.SetStateAction<{
      annexureOne: any,
      annexureTwo: any,
      annexureThree: any
    }>>;
     handleFileChange: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string, documentName?: string) => void;
     validationErrors?: {[key: string]: string}; // Add this
  isValidating?: boolean; // Add this
  clearValidationError?: (errorKey: string) => void; 
}

const SchemesPage = ({
  token,
  formData,
  handleFileChange,
  assistanceDetails,
  handleInputChange,
  handlePreviewFile,
  districtOptions,
  applicationId,
  id,
  editingIndex,
  setEditingIndex,
 
  updatedFields,
  existData,
  userDetail,
  setUpdatedFields,
  resubmittedFields,
  setResubmittedFields,
  getExistedApplication,
  unverifiedFields = [],
  userRole = '', 
   validationErrors = {}, 
    isValidating = false ,
    clearValidationError
}: APMCp1Props) => {

  
//----------------------------------Handle Select Changes----------------------------------
  const  options=
                          [
                            { label: "A", value: "A" },
                            { label: "B", value: "B" },
                            { label: "C", value: "C" },
                            { label: "D", value: "D" },
  
                          ];
                          const scheme =[{
  label: existData?.scheme?.name,
  value: existData?.scheme?.name
 }]

const[purposes, setPurposes] = useState<any[]>([]);


// const [resubmittedFields, setResubmittedFields] = useState({
//   annexureOne: {},
//   annexureTwo: {},
//   annexureThree: {}
// });

 
  const roleIdentifier = userDetail.Role.Role_Identifier;

  const isFieldUnverified = (fieldName: string): boolean => {
    return unverifiedFields.includes(fieldName);
  };

  // Helper function to check if buttons should be disabled
  const resubmissionButtons = (fieldName: string): boolean => {
    // If user is JC, disable all buttons
    // if (userRole === 'JC') {
    //   return true;
    // }
    
    // If user is SEC, only enable buttons for unverified fields
    if (userRole === 'SEC' || userRole === 'JC' || userRole === 'SC') {
      return !isFieldUnverified(fieldName);
    }
    
    // For other roles, follow existing logic or enable all
    return false;
  };

  // Helper function to get button styling
  // const getButtonStyling = (fieldName: string, baseClass: string): string => {
  //   if (resubmissionButtons(fieldName)) {
  //     return `${baseClass} disabled opacity-50`;
  //   }
  //   return baseClass;
  // };

//----------------------------------Validation state----------------------------------
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});
  const [showErrors, setShowErrors] = useState(false);
  const [editComment , setEditComment]= useState("");
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  
  // // Validation logic for each field
  // const validate = () => {
  //   const errors: { [key: string]: string } = {};
  //   if (!formData.district) errors.district = "District is required.";
  //   if (!formData.taluka) errors.taluka = "Taluka is required.";
  //   if (!formData.APMC) errors.APMC = "APMC is required.";
  //   if (!formData.district2) errors.district2 = "Category district is required.";
  //   if (!formData.categoryDoc) errors.categoryDoc = "Category document is required.";
  //   if (!formData.scheme) errors.scheme = "Scheme is required.";
  //   if (!formData.purpose) errors.purpose = "Purpose is required.";
  //   if (!formData.projectPlan1) errors.projectPlan1 = "Project plan is required.";
  //   if (!formData.projectPlan2) errors.projectPlan2 = "Project estimate is required.";
  //   if (!formData.percentage && formData.percentage !== 0) errors.percentage = "Percentage is required.";
  //   if (!formData.SORDoc) errors.SORDoc = "SOR document is required.";
  //   if (!formData.toolstDoc) errors.toolstDoc = "Tools document is required.";
  //   if (!formData.PWDDoc) errors.PWDDoc = "PWD document is required.";
  //   if (!formData.committeeName || formData.committeeName.trim() === "") errors.committeeName = "Committee name is required.";
  //   if (!formData.construction) errors.construction = "Please select Yes or No.";
  //   return errors;
  // };

  // const errors = validate();

//----------------------------------Mark input as touched on blur----------------------------------
  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
    setTouched(prev => ({ ...prev, [e.target.name]: true }));
  };

//----------------------------------Handle Changes----------------------------------


//----------------------------------Percentage(0-100)----------------------------------
const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const{name, value} = e.target;

  // Accept valid decimals up to 2 decimal places
  if (!/^\d{0,3}(\.\d{0,2})?$|^\d+\.$/.test(value)) return;

  // Prevent values > 100
  const num = parseFloat(value);
  if (!isNaN(num) && num > 100) return;

  handleInputChange({
    target: {
      name, value
    },
  } as any);
};

const handlePercentageBlur = () => {
  const value = formData.percentOfProjCostEligible;
  if (value && /^\d+\.?$/.test(value)) {
    const formatted = parseFloat(value).toFixed(2);
    handleInputChange({
      target: { name: "percentOfProjCostEligible", value: formatted },
    } as any);
  }
};



  //----------------------------- Div for the click of View Log-------------------------



   const handleUpdateSubmit = async (index: number, responses: any[],annexure:string) => {

  
    responses.forEach((res: any) => {
      const searchKey = res.responseVal;
 
      // Update text-based values
 
      // Update files (if applicable)
   
    });
    const transactionBy = roleIdentifier;
    const status = existData.status;
    const comment = editComment
    const oldValue: any[] = [];
    const newValue: any[] = [];
   const field = responses.find(res => res?.fieldName)?.fieldName ? responses.find(res => res?.fieldName)?.fieldName : responses.find(res => res.responseVal)?.responseVal
    

Object.entries(updatedFields).forEach(([fieldKey, updatedVal]: any) => {
  const fieldDataArray = existData?.[annexure]?.[field]?.data;

  // Skip if field data doesn't exist
  if (!Array.isArray(fieldDataArray)) return;

  let matched;

 
  if (updatedVal?.docId && updatedVal?.documentName) {
    matched = fieldDataArray.find(
      (item: any) =>
        item?.documentName === updatedVal.documentName && item?.docId !== updatedVal.docId // ensure it's different
    );

    if (matched) {
      oldValue.push({
        fieldValue: matched.docId || "",
        fieldName: updatedVal.documentName,
        fileName:matched?.fileName,
        fieldType: "doc"
      });
    }
  }
  else {
    matched = fieldDataArray.find(
      (item: any) => item?.fieldName === fieldKey
    );

    if (matched) {
      oldValue.push({
        fieldValue: matched?.value || "",
        fieldName: fieldKey,
        fieldType: "string"
      });
    }
  }
});


Object.entries(updatedFields).forEach(([fieldKey, updatedVal]: any) => {
  // Case 1: Document field
  if (updatedVal?.docId && updatedVal?.documentName) {
    newValue.push({
      fieldValue: updatedVal.docId,
      fieldName: updatedVal.documentName,
      fileName:updatedVal?.fileName,
      fieldType: "doc"
    });
  }
  // Case 2: Input/text field
  else {
    newValue.push({
      fieldValue: updatedVal,
      fieldName: fieldKey,
      fieldType: "string"
    });
  }
});


  const transaction = [
  {
    oldValue,
    newValue,
    transactionBy: roleIdentifier,
    status: existData.status,
    appStatusLevel: existData.appStatusLevel
  }
  ];


   const payload = {
      couchId: existData?.applicationDataId,
      fieldUpdated: field,
      annexureUpdated: annexure,
       isUpdated:true,
      isVerified: false,
      comment: comment,
      [`${field}`]:{
        transaction
      }
    
     
  }
 
  // setUpdatedFields({})

  const submitTransaction = await updateField(payload , token)


  if(submitTransaction?.result?.ok)
  { toast.success(submitTransaction?.message, {position:"top-right"})
     setEditingIndex(null); 
     setEditComment("");
     setUpdatedFields({})
     getExistedApplication();
  }
  else{
    
     toast.error(submitTransaction?.message, {position:"top-right"})
    setUpdatedFields({})

  }

 
  };





// )------------------------------BUTTONS FOR ACTIONS (verify, edit, comment)------------------------------
const ActionButtons = ({ fieldNo, fieldName }: { fieldNo: string; fieldName?: string }) => {
  const isDisabled = resubmissionButtons(fieldName || '');

  return (
    <>
      {!isDisabled && (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="tooltip-bottom">
              Edit
            </Tooltip>
          }
        >
          <button
            type="button"
            className="btn btn-outline-info w-75"
            style={{ minWidth: '80px' }}
            onClick={() =>
              setEditingIndex(editingIndex === parseInt(fieldNo) ? null : parseInt(fieldNo))
            }
          >
            Update
          </button>
        </OverlayTrigger>
      )}
    </>
  );
};


// ----------------------------------------Input Functions----------------------------------------

const selectFn = (fieldName: string , docName:string) => {



 // fallback

  // Always show the current value as an option if not present
  let selectedValue = null;
  
      // Add the current value as an option if not found
      selectedValue = { value: formData[fieldName], label: formData[fieldName] };
    let  options = [ selectedValue];
   
  const value =(roleIdentifier==="SEC"&&existData?.status!=="schemeGranted")? existData?.schemeFilledByApmcSecAnnexureOne?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value:existData?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value


  return (
  
    <div className="p-2 w-100 text-muted border rounded bg-light">
    {value}
  </div>
  );
};


const inputFn =(fieldName: string,docName:string)=>{
  return(
      <input
      type='text'
      className=" p-2  form-control"
      placeholder={`Enter ${fieldName}`}
      name={fieldName}
      value={(roleIdentifier==="SEC"&&existData?.status!=="schemeGranted")? existData?.schemeFilledByApmcSecAnnexureOne?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value:existData?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value || ""}
      onChange={handleInputChange}
      onBlur={handleBlur}
      disabled={ true}
      />
  )
}

const radioFn = (fieldName: string, docName: string,annexureType:string,annexure:string) => {




 
  const value =(roleIdentifier==="SEC"&&existData?.status!=="schemeGranted")? existData?.[`schemeFilledByApmcSec${annexure}`]?.[annexureType]?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value:existData?.[annexureType]?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value



  return (
    <div className="d-flex justify-start gap-2">
      <input
        type="radio"
        name={fieldName}
        value={value}
        checked={value === "yes"}
        disabled={true}
      />{" "}Yes
      <input
        type="radio"
        name={fieldName}
        value={value}
        checked={value === "no"}
        disabled={true}
      />{" "}No
    </div>
  );
};


// const fileButtonFn = (fieldName: string) => (
//   <button
//     type="button"
//     name={fieldName}
//     className="w-100 btn border bg-white fw-normal d-flex align-items-center gap-2 px-3 py-2"
//     onClick={() => handlePreviewFile(formData[fieldName])}
//   >
//     <i className="ti ti-eye"></i>
//     View Doc Preview
//   </button>
 
// );

const fileFn = (response: any) => (
  <input
    className={`form-control `}
    type="file"
    onChange={(e) => {
      // Pass the correct parameters: response.responseVal should be the document name
      // and response.fieldName should be the field name for API
      handleFileChange(e, response?.fieldName, response?.responseVal);
    }}
    name={response?.responseVal}
    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
    id={response?.responseVal}
  />
);

const fileButtonFn = (fieldName , docName,annexureType:string,annexure:string) => {
 
  const docData = (roleIdentifier==="SEC"&&existData?.status!=="schemeGranted")? existData?.[`schemeFilledByApmcSec${annexure}`]?.[annexureType]?.[fieldName]:existData?.[annexureType]?.[fieldName]
  const docId = docData?.data.find(data=>data.documentName == docName)?.docId;


  return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info w-100 align-items-center"
    onClick={() => {
      setSelectedDocId(docId);

    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
};
const purposeinputFn = (fieldName: string) => {
  const data =existData?.annexureOne?.estimateProjectCost?existData?.annexureOne?.estimateProjectCost?.data?.find((item: any) => item.fieldName === "estimateProjectCostAmount")?.value : [];
  
  return (
    <div className="space-y-2">
      {data?.map((item, index) => (
         <div key={item.id || index} className="border rounded p-3 bg-gray-50">
          <div className="mb-2">
            <span className="font-medium text-gray-700">Name: </span>
            <span>{item.name}</span>
          </div>
          <div>
            <span className="font-medium text-gray-700">Cost: </span>
            <span>₹{item.cost.toLocaleString()}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
const displayAllYards = () => {
  const mainYardData = existData?.mainYard || [];
  const subYardData = existData?.subYard || [];
  const allYards = [...mainYardData, ...subYardData];
  
  // Group purposes by yard name
  const groupedByYard = allYards.reduce((acc, item) => {
    if (!acc[item.yard]) {
      acc[item.yard] = [];
    }
    acc[item.yard].push(item.purpose);
    return acc;
  }, {});
  
 return (
  <div className="space-y-2">
    {Object.entries(groupedByYard).map(([yardName, purposes], index) => (
      <div key={index} className="border rounded text-sm">
        <div className="px-2 py-1.5 font-semibold" style={{backgroundColor:"#CCE3FF"}}>
          {yardName}
        </div>
        <div className="px-2 py-1 bg-white">
          {Array.isArray(purposes) && purposes.map((purpose, pIndex) => (
            <div key={pIndex} className="text-gray-700 py-0.5 pl-2">
              • {purpose}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
};
const fileButtonFnassistance = (fieldName:string , docName:string,anexxure:string) => {
    let docData:any;
    let docId:any;
if(fieldName==="hasAssistanceApproved"){
 
     docData = existData?.[anexxure]?.[fieldName];
   
       docId = docData?.data.find((data:any)=>data.fieldName == docName)?.value?.completion?.docId;
     
}else
 {  docData = existData?.[anexxure]?.[fieldName];
     docId = docData?.data.find((data:any)=>data.documentName == docName)?.docId;
 }
 


  return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info w-75 m-2 align-items-center"
    onClick={() => {
      setSelectedDocId(docId);
     
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
};

const percentageFn = (fieldName: string,docName:string) => (
  <input
    className="form-control"
    type="text"
    inputMode="decimal"
    name={fieldName}
    placeholder="0 - 100"
    value={(roleIdentifier==="SEC"&&existData?.status!=="schemeGranted")? existData?.schemeFilledByApmcSecAnnexureOne?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value:existData?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value ?? ""}
    onChange={handlePercentageChange}
    onBlur={handlePercentageBlur}
    disabled={ true}
  />
);


const getpurpose=async(scheme)=>{
  try{
        const resp= await getApmcPurposes(scheme)
    const rawPurposes = resp?.data.map((item: any) => ({
      label: item.subName,
      value: item.subName,
    }));
    setPurposes(rawPurposes);
  
    
    // setPurposes(rawPurposes)
      }catch(error){
    
      }
}
useEffect(() => {
    // Fetch purposes based on selected scheme
 if (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") ){
   getpurpose(existData?.scheme?.name)
 }
  }, []);
const renderInputElement = (
  responseType: string, 
  fieldName: string, 
  annexureType: string = "annexureOne",
  responseVal?: string,

) => {
  const errorKey = `${annexureType}_${fieldName}`;
  const hasError = validationErrors && validationErrors[errorKey];
  const isFieldUnverifiedForValidation = unverifiedFields.includes(fieldName);
  
  // Show validation for unverified fields in SEC role
  const shouldShowValidation = userRole === 'SEC' && isFieldUnverifiedForValidation && hasError;

  const inputClassName = `form-control ${shouldShowValidation ? 'border-danger' : ''}`;
  const selectClassName = `form-select ${shouldShowValidation ? 'border-danger' : ''}`;

  const renderError = () => {
    if (!shouldShowValidation) return null;
    return (
      <div className="mt-1">
        <span className="text-danger small d-flex align-items-center">
          <i className="feather feather-alert-circle me-1"></i>
          {hasError}
        </span>
      </div>
    );
  };

  const getCurrentValue = () => {
    return resubmittedFields[annexureType]?.[fieldName]?.find( (item) => item.fieldName ===responseVal
            )?.value || "";
  };

  switch (responseType) {
    case "input":
      return (
        <div>
          <input 
            type="text" 
            className={inputClassName}
            name={responseVal} 
            placeholder={`Enter ${responseVal}`}
            value={getCurrentValue()}
            onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType,responseVal)}
          />
          {renderError()}
        </div>
      );
      
    case "select":
      return (
        <div>
          <select 
            className={selectClassName}
            name={responseVal}
            value={getCurrentValue()}
            onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType,responseVal)}
          >
            <option value="">Select option</option>
            {options?.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          {renderError()}
        </div>
      );
      
    case "radio":
      return (
        <div>
          <div className="d-flex gap-3">
            <label>
              <input 
                type="radio" 
                name={`update_${responseVal}_${fieldName}`} 
                value="yes"
                checked={getCurrentValue() === "yes"}
                onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType,responseVal)}
              /> Yes
            </label>
            <label>
              <input 
                type="radio" 
                name={`update_${responseVal}_${fieldName}`} 
                value="no"
                checked={getCurrentValue() === "no"}
                onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType,responseVal)}
              /> No
            </label>
          </div>
          {renderError()}
        </div>
      );
      
    case "percentage":
      return (
        <div>
          <input
            type="text"
            inputMode="decimal"
            className={inputClassName}
            name={responseVal}
            placeholder="0-100"
            value={getCurrentValue()}
            onChange={(e) => handleResubmissionPercentageChange(e, fieldName, annexureType)}
          />
          {renderError()}
        </div>
      );
      
    case "button":
    case "file":
      return (
        <div>
          <input 
            type="file" 
            className={inputClassName}
            name={responseVal}
            onChange={(e) => handleResubmissionFileChange(e, fieldName, annexureType)}
            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
          />
          {renderError()}
          {/* Show current file name if exists */}
          {resubmittedFields[annexureType]?.[fieldName]?.data?.[0]?.fileName && (
            <small className="text-success mt-1 d-block">
              Uploaded: {resubmittedFields[annexureType][fieldName].find( (item) => item.documentName === responseVal)?.fileName}
            </small>
          )}
        </div>
      );
      
    default:
      return <div className="text-muted">Unsupported field type: {responseType}</div>;
  }
};



// Update handleResubmissionInputChange to clear validation errors
const handleResubmissionInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, 
  fieldName: string, 
  annexureType: string,
  responseVal?: string
) => {
   const { name, value } = e.target;
    setResubmittedFields(prev => {
      // Ensure annexure object exists
      const annex = prev?.[annexureType] ? { ...prev[annexureType] } : {};
      const arr = Array.isArray(annex[fieldName]) ? [...annex[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === responseVal);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: responseVal });
      }
     
      return { ...prev, [annexureType]: { ...annex, [fieldName]: arr } };
    });


  // Clear validation error for this field when user starts typing
  const errorKey = `${annexureType}_${fieldName}`;
  if (clearValidationError && validationErrors && validationErrors[errorKey] && value.trim() !== '') {
    clearValidationError(errorKey);
  }

};

// Helper to update nested assistance details for resubmission (details_1, details_2, ...)
const handleResubmissionAssistanceDetailChange = (index: number, key: string, value: any) => {
  const fieldName = `details_${index + 1}`;
  setResubmittedFields(prev => {
    const annex = prev?.['annexureThree'] ? { ...prev['annexureThree'] } : {};
    const arr = Array.isArray(annex['hasAssistanceApproved']) ? [...annex['hasAssistanceApproved']] : [];
    const idx = arr.findIndex((item: any) => item.fieldName === fieldName);
    if (idx !== -1) {
      const existing = { ...arr[idx] };
      const valObj = (existing.value && typeof existing.value === 'object') ? { ...existing.value } : {};
      valObj[key] = value;
      arr[idx] = { ...existing, value: valObj };
    } else {
      const valObj: any = {};
      valObj[key] = value;
      arr.push({ fieldName: fieldName, value: valObj });
    }
    return { ...prev, annexureThree: { ...annex, hasAssistanceApproved: arr } };
  });

  // Clear validation for this field if present
  const errorKey = `annexureThree_hasAssistanceApproved`;
  if (clearValidationError && validationErrors && validationErrors[errorKey]) {
    clearValidationError(errorKey);
  }
};

const getResubmittedAssistanceDetailValue = (index: number, key: string) => {
  const fieldName = `details_${index + 1}`;
  const arr = resubmittedFields?.annexureThree?.hasAssistanceApproved || [];
  const item = Array.isArray(arr) ? arr.find((i: any) => i.fieldName === fieldName) : undefined;
  return item?.value?.[key] ?? "";
};

// Handler for percentage input changes
const handleResubmissionPercentageChange = (
  e: React.ChangeEvent<HTMLInputElement>, 
  fieldName: string, 
  annexureType: string
) => {
  
  


  const { name, value } = e.target;
    // Validate percentage format
  if (!/^\d{0,3}(\.\d{0,2})?$|^\d+\.$/.test(value)) return;

  const num = parseFloat(value);
  if (!isNaN(num) && num > 100) return;
    setResubmittedFields(prev => {
      const annex = prev?.[annexureType] ? { ...prev[annexureType] } : {};
      const arr = Array.isArray(annex[fieldName]) ? [...annex[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [annexureType]: { ...annex, [fieldName]: arr } };
    });

  // Clear validation error
  const errorKey = `${annexureType}_${fieldName}`;
  if (clearValidationError && validationErrors && validationErrors[errorKey] && value.trim() !== '') {
    clearValidationError(errorKey);
  }


};


// Handler for file changes
// Handler for file changes
const handleResubmissionFileChange = async (
  e: React.ChangeEvent<HTMLInputElement>,
  fieldName: string,
  annexureType: string
) => {
const { name, files } = e.target;
    if (!files) return;
     
      const file = files[0];
      const fileName = file.name;
 
 
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentName", name);
    formData.append("fieldName", fieldName);
   
    // Get application and scheme IDs from existData
    const applicationId = existData?.ApmcSchemeTransaction?.[0]?.applicationId ||
                         existData?.applicationId || "";
    const schemeId = existData?.scheme?.id || existData?.schemeId || "";
   
    formData.append("applicationId", applicationId);
    formData.append("schemeId", schemeId);
 
    // Get existing docId for update
    const getExistingDocId = (annexureType: string, fieldName: string) => {
      const annexureData = existData?.[annexureType]?.[fieldName]?.data;
      if (!annexureData) return null;
     
      return annexureData.find((data: any) =>
        data.documentName === name || data.fieldName === name
      )?.docId || null;
    };
 
    const existingDocId = getExistingDocId(annexureType, fieldName);
   
    const uploadResponse = await submitApmcFiles(formData, token, existingDocId);
   
    if (uploadResponse.success && uploadResponse.docId) {
      // Update resubmitted fields with uploaded file info
      if (fieldName.startsWith('details_') && annexureType === 'annexureThree') {
        // For nested assistance detail completion doc, store under details_n.value.completion
        const detailField = fieldName; // details_n
        setResubmittedFields(prev => {
          const annex = prev?.['annexureThree'] ? { ...prev['annexureThree'] } : {};
          const arr = Array.isArray(annex['hasAssistanceApproved']) ? [...annex['hasAssistanceApproved']] : [];
          const idx = arr.findIndex((item: any) => item.fieldName === detailField);
          if (idx !== -1) {
            const existing = { ...arr[idx] };
            const valObj = (existing.value && typeof existing.value === 'object') ? { ...existing.value } : {};
            valObj.completion = { docId: uploadResponse.docId, fileName: fileName,documentName: "workCompletionDetails" };
            arr[idx] = { ...existing, value: valObj };
          } else {
            arr.push({ fieldName: detailField, value: { completion: { docId: uploadResponse.docId, fileName: fileName,documentName: "workCompletionDetails" } } });
          }
          return { ...prev, annexureThree: { ...annex, hasAssistanceApproved: arr } };
        });
      } else {
        setResubmittedFields(prev => {
          const annex = prev?.[annexureType] ? { ...prev[annexureType] } : {};
          const arr = Array.isArray(annex[fieldName]) ? [...annex[fieldName]] : [];
          const index = arr.findIndex(item => item.documentName === name);
          if (index !== -1) {
            arr[index] = { docId: uploadResponse?.docId, documentName: name, fileName: fileName };
          } else {
            arr.push({ docId: uploadResponse?.docId, documentName: name, fileName: fileName });
          }
          return { ...prev, [annexureType]: { ...annex, [fieldName]: arr } };
        });
      }
 
 
      // Clear validation error
      const errorKey = `${annexureType}_${fieldName}`;
      if (clearValidationError && validationErrors && validationErrors[errorKey]) {
        clearValidationError(errorKey);
      }
 
      toast.success("File uploaded successfully!");
   
    } else {
      toast.error(`File upload failed: ${uploadResponse.message || 'Unknown error'}`);
     
    }
  } catch (error) {
 
    toast.error("File upload failed due to network error");
  }
};
 







  return (
    <>
    <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
          <div id='table' className='w-100 overflow-hidden border border-secondary bg-white rounded mb-5'>
            <div id='head' className='d-flex w-100 rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                <h4 className='col-5 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                <div className='col-6 d-flex justify-content-center align-items-center'>
                  <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  ((existData?.status === "resubmission"||existData?.status==="reject") &&
   ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ"))))
    ? "col-6"
    : "col-12"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status === "resubmission"||existData?.status==="reject")&&((userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))||userRole === "JC" || userRole === "SC") && (
      <h4 className="col-6 p-2 justify-content-center d-flex align-items-center">
        ક્રિયા (Action)
      </h4>
    )}
                </div>
            </div>

            {formFieldDataP1 && formFieldDataP1.length > 0 &&
            formFieldDataP1.map((item, index) => {
              // Get the main field name for this item
              const mainFieldName = item.response?.[0]?.fieldName || '';
              const isUnverified = isFieldUnverified(mainFieldName);
              
                

              return (
                <React.Fragment key={index}>
                  <div className={`d-flex border-top border-secondary`}>
                    <h4 className={`col-1 d-flex align-items-center justify-content-center ${isUnverified ? 'text-warning fw-bold' : ''}`}>{item.fieldNo}</h4>
                    <div className='col-5 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2'>
                      <p className={isUnverified ? 'text-warning fw-bold' : ''}>{item.fieldVal}*</p>
                      
                    </div>
                    <div className='col-6 d-flex'>
                      <div   className={`p-2 justify-content-center flex-column gap-2 d-flex align-items-center border-end border-secondary ${
     ((existData?.status === "resubmission"||existData?.status==="reject") &&
     ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ")))) ? "col-6" : "col-12"
      }`}>
                        {item.response.map((newObj, indx) => {
                          if(!newObj.roles.includes(roleIdentifier)){
                            return
                          }
                          const fieldName = newObj?.fieldName;
                          const docName = newObj.responseVal;
                          const inputKey = `${index}_${indx}`;
                          const divVal =
                            newObj.responseType === "select" ? selectFn(fieldName, docName) :
                            newObj.responseType === "input" ? inputFn(fieldName,docName) :
                                newObj.responseType === "purposeinput" ? purposeinputFn(docName) :
                             newObj.responseType === "selectyard" ? displayAllYards() :
                            newObj.responseType === "radio" ? radioFn(fieldName, docName,"annexureOne","AnnexureOne") :
                            newObj.responseType === "percentage" ? percentageFn(fieldName,docName) :
                            newObj.responseType === "button" ? fileButtonFn(fieldName, docName,"annexureOne","AnnexureOne") :
                            newObj.responseType === "file" ? fileFn(fieldName) :
                            null;

                          return (
                            <div className='w-75' key={inputKey}>
                              {divVal}
                              {fieldName === "projectPlan1" && (
                                <span className="text-info small mt-1">Project Plan</span>
                              )}
                              {fieldName === "projectPlan2" && (
                                <span className="text-info small mt-1">Estimation Cost</span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                  { (existData?.status === "resubmission" || existData?.status==="reject") &&      <div className="col-6 d-flex p-2 gap-2 flex-column flex-lg-column align-items-center justify-content-center">
                          {(roleIdentifier === "JC" || roleIdentifier === "SC") ? (
                            <ActionButtons fieldNo={`${index}`} fieldName={mainFieldName} />
                          ) : (
                            (roleIdentifier === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")&&isUnverified ) &&
                              item.resubmissionResponse.map((newObj, indx) => {
                                const fieldName = newObj?.fieldName;
                                const responseType = newObj?.responseType;
                                const inputKey = `${index}_${indx}`;

                                return (
                                  <div className="w-75 d-flex flex-column" key={inputKey}>
                                    {renderInputElement(responseType, fieldName, "annexureOne",newObj?.responseVal)}
                                  </div>
                                );
                              })
                          )}
                        </div>}


                    </div>
                  </div>

                  {/* UPDATE SECTION */}
                  <EditSection
                      editingIndex={editingIndex}
                      currentIndex={index}
                      item={item}
                      updatedFields={updatedFields}
                      setUpdatedFields={setUpdatedFields} 
                      handleFileChange={handleFileChange}
                      handlePercentageChange={handlePercentageChange}
                      handlePercentageBlur={handlePercentageBlur}
                      handleUpdateSubmit={handleUpdateSubmit}
                      annexure={"annexureOne"}
                    />
                </React.Fragment>
              );
            })}
            
 
          </div>
        </div>

      </div>
      </div>
    <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
          <div id='table' className='w-100 overflow-hidden border border-secondary bg-white rounded mb-5'>
            <div id='head' className='d-flex w-100 rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                <h4 className='col-5 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                <div className='col-6 d-flex justify-content-center align-items-center'>
                <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  ((existData?.status === "resubmission"||existData?.status==="reject") &&
   ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ")))) ? "col-6" : "col-12"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status === "resubmission"||existData?.status==="reject")&&((userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")) || userRole === "JC" || userRole === "SC") && (
      <h4 className="col-6 p-2 justify-content-center d-flex align-items-center">
        ક્રિયા (Action)
      </h4>
    )}
                </div>
            </div>
                      <div className='d-flex border-top border-secondary'>
                      <h4 className='col-1 d-flex align-items-center justify-content-center '>09.</h4>
                      <p className=' border-start border-secondary p-2'>નીચે મુજબની બાંહેધરીઓ / પ્રમાણપત્રો (Following undertakings/certificates to be submitted:)</p>
                    </div>
                    {formFieldDataP2 && formFieldDataP2.length > 0 &&
                    formFieldDataP2.map((item, index) => {
                      // Get the main field name for this item
                      const mainFieldName = item.response?.[0]?.fieldName || '';
                      const isUnverified = isFieldUnverified(mainFieldName);
                      
                      return (
                        <React.Fragment key={index}>
                          <div className={`d-flex border-top border-secondary`}>
                            <h4 className='col-1'></h4>
                            <div className='col-5 d-flex gap-2 border-start border-end border-secondary'>
                              
                            <h4 className={`col-2 d-flex align-items-center justify-content-center border-end border-secondary ${isUnverified ? 'text-warning fw-bold' : ''}`}>
                              {index < 9 ? `0${index + 1}.` : `${index + 1}.`}
                              </h4>
                              <p className={`w-100 p-2 ${isUnverified ? 'text-warning fw-bold' : ''}`}>
                                {item.fieldVal}*
                              </p>
                              
                            </div>
                            
                            <div className='col-6 d-flex'>
                                               <div   className={`p-2 justify-content-center flex-column gap-2 d-flex align-items-center border-end border-secondary ${
     ((existData?.status === "resubmission"||existData?.status==="reject") &&
   ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ")))) ? "col-6" : "col-12"
      }`}>
                                {item.response.map((newObj, indx) => {
                                  const fieldName = newObj?.fieldName;
                                  const docName = newObj.responseVal;
                                  const inputKey = `${index}_${indx}`;
                                  const divVal =
                                    newObj.responseType === "button" ? fileButtonFn(fieldName, docName,"annexureTwo","AnnexureTwo") :
                                    newObj.responseType === "file" ? fileFn(fieldName) :
                                    null;

                                  return (
                                    <div className='w-75' key={inputKey}>
                                      {divVal}
                                    </div>
                                  );
                                })}
                              </div>
                         {  (existData?.status === "resubmission" || existData?.status==="reject") &&   <div className="col-6 d-flex p-2 gap-2 flex-column flex-lg-column align-items-center justify-content-center">
                                {(roleIdentifier === "JC" || roleIdentifier === "SC") ? (
                                  <ActionButtons fieldNo={`${index}`} fieldName={mainFieldName} />
                                ) : (
                                  !resubmissionButtons(mainFieldName || "") &&
                                   (roleIdentifier === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")&&isUnverified )&&
                                    item.resubmissionResponse.map((newObj, indx) => {
                                      const fieldName = newObj?.fieldName;
                                      const responseType = newObj?.responseType;
                                      const inputKey = `${index}_${indx}`;

                                      return (
                                        <div className="w-75 mb-2 d-flex flex-column" key={inputKey}>
                                          {renderInputElement(responseType, fieldName, "annexureTwo",newObj?.responseVal)}
                                        </div>
                                      );
                                    })
                                )}
                              </div>}
                            </div>
                          </div>
                          
                          {/* UPDATE SECTION for P2 */}
                         <EditSection
                            editingIndex={editingIndex}
                            currentIndex={index}
                            item={item}
                            updatedFields={updatedFields}
                            setUpdatedFields={setUpdatedFields} 
                            handleFileChange={handleFileChange}
                            handlePercentageChange={handlePercentageChange}
                            handlePercentageBlur={handlePercentageBlur}
                            handleUpdateSubmit={handleUpdateSubmit}
                            annexure={"annexureTwo"}
                          />
                        </React.Fragment>
                      );
                    })}
         
                  </div>
                </div>
      </div>
      </div>
        <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
          <div id='table' className='w-100 overflow-hidden border border-secondary bg-white rounded mb-5'>
            <div id='head' className='d-flex w-100 rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                <h4 className='col-5 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                <div className='col-6 d-flex justify-content-center align-items-center'>
                <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  ((existData?.status === "resubmission"||existData?.status==="reject") &&
 ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ")))) ? "col-6" : "col-12"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status === "resubmission"||existData?.status==="reject")&&((userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")) || userRole === "JC" || userRole === "SC") && (
      <h4 className="col-6 p-2 justify-content-center d-flex align-items-center">
        ક્રિયા (Action)
      </h4>
    )}
                </div>
            </div>

            {formFieldDataP3 && formFieldDataP3.length > 0 &&
            formFieldDataP3.map((item, index) => {
              // Get the main field name for this item
              const mainFieldName = item.response?.[0]?.fieldName || '';
              const isUnverified = isFieldUnverified(mainFieldName);
              
              // if ((item.actionNo === "20" || item.actionNo === "21") && (roleIdentifier === "SEC"|| roleIdentifier === "JC")) {
              //         return null; // skip rendering
              //       }
          

              return (
                <React.Fragment key={index}>
                  <div className={`d-flex border-top border-secondary `}> 
                    <h4 className={`col-1 d-flex align-items-center justify-content-center ${isUnverified ? 'text-warning fw-bold' : ''}`}>{item.fieldNo}</h4>
                    <div className='col-5 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2'>
                      <p className={isUnverified ? 'text-warning fw-bold' : ''}>{item.fieldVal}*</p>
                      
                    </div>
                    <div className='col-6 d-flex'>
                                <div   className={`p-2 justify-content-center flex-column gap-2 d-flex align-items-center border-end border-secondary ${
     ((existData?.status === "resubmission"||existData?.status==="reject") &&
 ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ"))|| (userRole === "JC" || userRole === "SC" && (existData?.appStatusLevel!=="pendingAtApmcResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmission"||existData?.appStatusLevel!=="pendingAtApmcHOResubmissionAfterHARQ")))) ? "col-6" : "col-12"
      }`}>
                        {item.response.map((newObj, indx) => {
                          const fieldName = newObj?.fieldName;
                          const docName = newObj.responseVal;
                          const inputKey = `${index}_${indx}`;
                          const divVal =
                            newObj.responseType === "select" ? selectFn(fieldName, docName) :
                            newObj.responseType === "input" ? inputFn(fieldName,docName) :
                            newObj.responseType === "radio" ? radioFn(fieldName, docName,"annexureThree","AnnexureThree") :
                            newObj.responseType === "percentage" ? percentageFn(fieldName,docName) :
                            newObj.responseType === "button" ? fileButtonFn(fieldName, docName,"annexureThree","AnnexureThree") :
                            newObj.responseType === "file" ? fileFn(fieldName) :
                            null;

                          return (
                            <div className='w-75' key={inputKey}>
                              {divVal}
                            </div>
                          );
                        })}
                      </div>
                  {(existData?.status === "resubmission" || existData?.status==="reject") &&    <div className="col-6 d-flex p-2 gap-2 flex-column flex-lg-column align-items-center justify-content-center">
                      {(roleIdentifier === "JC" || roleIdentifier === "SC")? (
                    (  item?.fieldNo!=="11."&&  <ActionButtons fieldNo={`${index}`} fieldName={mainFieldName} />)
                      ) : (
                        !resubmissionButtons(mainFieldName || "") &&
                         (roleIdentifier === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ")&&isUnverified )&&
                          item.resubmissionResponse.map((newObj, indx) => {
                            const fieldName = newObj?.fieldName;
                            const responseType = newObj?.responseType;
                            const inputKey = `${index}_${indx}`;

                            return (
                              <div className="w-75 mb-2 d-flex flex-column" key={inputKey}>
                                {renderInputElement(responseType, fieldName, "annexureThree",newObj?.responseVal)}
                              </div>
                            );
                          })
                      )}
                  </div>}
                    </div>
                  </div>
                      {item.fieldNo === "11." && existData?.annexureThree?.hasAssistanceApproved?.data.find(data=>data?.fieldName==="isApproved")?.value === "yes" && (
                     
                                               <>
                                                 {assistanceDetails.map((block, index) => (
                                                   <React.Fragment key={index}>
                                                     {/* 🔷 Heading */}
                                                     <div className="d-flex px-3 border-secondary border-top py-2 bg-light">
                                                       <strong>{['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][index]} Detail</strong>
                                                     </div>
                     
                                                     {/* 01. Date */}
                                                     <div className="d-flex border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">01.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">ક્યારે (Date) *</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                     <>      {block?.dateField && (
                      <div className="w-75 m-2 p-2 bg-light border rounded">
         
          <div >{block?.dateField}</div>
        </div>
      )}
                                                           <input
                                                             type="date"
                                                             className="form-control w-75 m-2"
                                                             value={getResubmittedAssistanceDetailValue(index, 'date')|| ''}
                                                             onChange={(e) => handleResubmissionAssistanceDetailChange(index, 'date', e.target.value)}
                                                             max="2100-12-31"
                                                           />
                                                           </>  
                                                         ) : (
                                                           <input
                                                             type="date"
                                                             className="form-control w-75 m-2"
                                                             value={block?.dateField}
                                                             max="2100-12-31"
                                                             disabled={true}
                                                           />
                                                         )}
                                                       </div>
                                                     </div>
                     
                                                     {/* 02. Scheme / Purpose */}
                                                     <div className="d-flex border-bottom border-top border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">02.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">યોજના, હેતુ (Scheme, Purpose) *</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                                                
                                                            { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                              <>
                                                                   <input
                                                                  type="text"
                                                                  className="form-control w-75 m-2"
                                                                  value={block?.scheme2}
                                                                  max="2100-12-31"
                                                                  disabled={true}
                                                                />
                                                              
                                                             
                                                                 <CommonSelect
                                      className="w-75 m-2"
                                      options={scheme}
                                      value={getResubmittedAssistanceDetailValue(index, 'scheme') ? scheme.find(opt => opt.value === getResubmittedAssistanceDetailValue(index, 'scheme')) : undefined}
                                      name="scheme"
                                      onChange={(option) =>
                                        handleResubmissionAssistanceDetailChange(
                                          index,
                                          'scheme',
                                          option ? option.value : ''
                                        )
                                      }
                                      placeholder="Select Scheme"
                                    />
                                                                      <input
                                                                  type="text"
                                                                  className="form-control w-75 m-2"
                                                                  value={block?.purpose2}
                                                                  max="2100-12-31"
                                                                  disabled={true}
                                                                />
                                                            <CommonSelect
                                      className="w-75 m-2"
                                      options={purposes}
                                      value={getResubmittedAssistanceDetailValue(index, 'purpose') ? purposes.find(opt => opt.value === getResubmittedAssistanceDetailValue(index, 'purpose')) : undefined}
                                      name="purpose"
                                      onChange={(option) =>
                                        handleResubmissionAssistanceDetailChange(
                                          index,
                                          'purpose',
                                          option ? option.value : ''
                                        )
                                      }
                                      placeholder="Select Purpose"
                                    />
                                                              </>
                                                            ) : (
                                                              <>
                                                                <input
                                                                  type="text"
                                                                  className="form-control w-75 m-2"
                                                                  value={block?.scheme2}
                                                                  max="2100-12-31"
                                                                  disabled={true}
                                                                />
                                                                <input
                                                                  type="text"
                                                                  className="form-control w-75 m-2"
                                                                  value={block?.purpose2}
                                                                  max="2100-12-31"
                                                                  disabled={true}
                                                                />
                                                              </>
                                                            )}
                                                       
                                                       </div>
                                                     </div>
                     
                                                     {/* 03. Amount */}
                                                     <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">03.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">મંજૂર થયેલ રકમ (Sanctioned Amount)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                          <>
                                                              <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block.sanctionedAmount}
                                                           />
                                                          <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             value={getResubmittedAssistanceDetailValue(index, 'amount')  || ''}
                                                             onChange={(e) => handleResubmissionAssistanceDetailChange(index, 'amount', e.target.value)}
                                                           />
                                                           </>
                                                         ) : (
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block.sanctionedAmount}
                                                           />
                                                         )}
                                                  
                                                       </div>
                                                     </div>
   <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">04.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">મળેલ સહાય  (Assistance Received)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                          <>
                                                             <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.assistanceReceived}
                                                           />
                                                          <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             value={getResubmittedAssistanceDetailValue(index, 'assistance')  || ''}
                                                             onChange={(e) => handleResubmissionAssistanceDetailChange(index, 'assistance', e.target.value)}
                                                           />
                                                           </>
                                                         ) : (
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.assistanceReceived}
                                                           />
                                                         )}
                                                  
                                                       </div>
                                                     </div>
                                                        <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">05.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">કુલ ખર્ચ (Total Expenditure)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                           <>
                                                            <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.totalExpenditure}
                                                           />
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             value={getResubmittedAssistanceDetailValue(index, 'expenditure') || ''}
                                                             onChange={(e) => handleResubmissionAssistanceDetailChange(index, 'expenditure', e.target.value)}
                                                           />
                                                           </>
                                                         ) : (
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.totalExpenditure}
                                                           />
                                                         )}
                                                  
                                                       </div>
                                                     </div>
                                                        <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">06.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">વધ / ધટ (Excess / Shortfall)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                           <>
                                                              <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.shortfall}
                                                           />
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             value={getResubmittedAssistanceDetailValue(index, 'shortfall')  || ''}
                                                             onChange={(e) => handleResubmissionAssistanceDetailChange(index, 'shortfall', e.target.value)}
                                                           />
                                                           </>
                                                         ) : (
                                                           <input
                                                             type="text"
                                                             className="w-75 m-2 form-control"
                                                             placeholder="Enter Amount"
                                                             disabled={true}
                                                             value={block?.shortfall}
                                                           />
                                                         )}
                                                  
                                                       </div>
                                                     </div>
                                                        <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">07.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">કામ પુર્ણ થયાની વિગતો (Details of Work Completion)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                        { (roleIdentifier === "SEC" && (existData?.status === "resubmission" || existData?.status === "reject") && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmissionAfterHARQ") && isUnverified) ? (
                                                          <>
                                               {             fileButtonFnassistance("hasAssistanceApproved", `details_${index+1}`,'annexureThree')}
                                                            <input
                                                              type="file"
                                                              className="form-control w-75 m-2"
                                                              name={`details_${index+1}`}
                                                              accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                                                              onChange={(e) => handleResubmissionFileChange(e, `details_${index+1}`, 'annexureThree')}
                                                            />
                                                            {/* show resubmitted uploaded file or existing file name */}
                                                            { (typeof getResubmittedAssistanceDetailValue(index, 'completion') === 'object' && getResubmittedAssistanceDetailValue(index, 'completion')?.fileName) && (
                                                              <small className="text-success mt-1">Uploaded: {getResubmittedAssistanceDetailValue(index, 'completion')?.fileName}</small>
                                                            ) }
                                                          </>
                                                        ) : (
                                                          fileButtonFnassistance("hasAssistanceApproved", `details_${index+1}`,'annexureThree')
                                                        )}
                                                       </div>
                                                     </div>
                                                       {/* <div className="d-flex border-bottom border-secondary">
                                                       <h4 className="col-1"></h4>
                                                       <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                                         <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">08.</h4>
                                                         <p className="col-10 p-2 d-flex align-items-center">શેરો – Share (or Contribution/Ratio, depending on context)*</p>
                                                       </div>
                                                       <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                                                         <input
                                                           type="text"
                                                           className="w-75 m-2 form-control"
                                                           placeholder="Enter Amount"
                                                           disabled={true}
                                                           value={block?.contributionRatio}
                                                        
                                                         />
                                                 
                                                       </div>
                                                     </div> */}
                                                  
                     
                     
                     
                                                   </React.Fragment>
                                                 ))}
                                               </>
                                             )}
                  {/* UPDATE SECTION for P3 */}
                  <EditSection
                  editingIndex={editingIndex}
                  currentIndex={index}
                  item={item}
                  updatedFields={updatedFields}
                  setUpdatedFields={setUpdatedFields} 
                  handleFileChange={handleFileChange}
                  handlePercentageChange={handlePercentageChange}
                  handlePercentageBlur={handlePercentageBlur}
                  handleUpdateSubmit={handleUpdateSubmit}
                  annexure={"annexureThree"}
                />
                
                </React.Fragment>


              );
            })}
            
 
          </div>
         
        </div>

      </div>
      </div>
       <div className="row p-3">
                                            {existData && existData?.licDoc !== null && (
                                              <div className="col-sm-12 d-flex justify-content-end">
                                                {/* <button
                                                  onClick={() => {
                                                    handleDownload();
                                                  }}
                                                  className="bg-success rounded text-white px-4 py-2"
                                                >
                                                  {language.download_license}
                                                </button> */}
                  
                                                 {(() => {
                                                  const latestLicense = existData?.licDoc // Get the last license
                  
                                                  return latestLicense ? (
                                                    <Link
                                                      key={latestLicense}
                                                      to="#"
                                                      data-bs-toggle="modal"
                                                      data-inert={true}
                                                      data-bs-target="#apmc_modal"
                                                      className="btn btn-success align-items-center"
                                                      onClick={() => setSelectedDocId(latestLicense)}
                                                    >
                                                      Download Sealed Document
                                                    </Link>
                                                  ) : null;
                                                })()}
                                              </div>
                                            )}
                                          </div>
      <SingleView docId={selectedDocId} type='scheme' />
      
    </>
  )
}

export default SchemesPage